const ValidationMessage = ({ validation, onSuggestionClick }) => {
  if (!validation) return null;

  const { isValid, isConsistent, errors, invalidItems, validItems, totalItems, message, suggestion } =
    validation;

  if (!isConsistent) {
    return (
      <div className="mt-3 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-md">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm text-yellow-700 font-medium">Input Type Mismatch</p>
            <p className="mt-1 text-sm text-yellow-600">{message}</p>
            {suggestion && onSuggestionClick && (
              <button
                onClick={onSuggestionClick}
                className="mt-2 text-sm text-yellow-800 underline hover:text-yellow-900"
              >
                {suggestion}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (!isValid && errors?.length > 0) {
    return (
      <div className="mt-3 p-4 bg-red-50 border-l-4 border-red-400 rounded-r-md">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm text-red-700 font-medium">Validation Errors</p>
            <div className="mt-2 text-sm text-red-600">
              <p>
                Found {validItems} valid and {invalidItems?.length || 0} invalid identifiers out of{' '}
                {totalItems} total.
              </p>
              {errors.map((error, index) => (
                <p key={index} className="mt-1">
                  • {error}
                </p>
              ))}
            </div>

            {invalidItems?.length > 0 && invalidItems.length <= 5 && (
              <div className="mt-3">
                <p className="text-sm text-red-700 font-medium mb-2">Invalid identifiers:</p>
                <div className="bg-red-100 rounded p-2 text-xs text-red-800 max-h-32 overflow-y-auto">
                  {invalidItems.map((item, index) => (
                    <div key={index} className="mb-1">
                      <span className="font-mono">Line {item.line}:</span> {item.reason}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {invalidItems?.length > 5 && (
              <div className="mt-3">
                <p className="text-sm text-red-700">
                  Too many errors to display. Please check your input format.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ValidationMessage;
